import React from 'react'
import SignIn from './SignIn'
import SignUp from './SignUp'
import { Box, Paper, Stack, Typography } from '@mui/material'
import frecallLogoFull from '../../assets/frecall-logofull.png'

const Auth = (props) => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 2,
        py: 4,
        background: (theme) => theme.palette.mode === "dark" ?
          "radial-gradient(circle at 15% 10%, #1f2c29 0%, #151d1b 45%, #101614 100%)" :
          "radial-gradient(circle at 15% 10%, #d7efe8 0%, #eaf5f1 38%, #f5faf8 100%)",
      }}
    >
      <Paper
        elevation={6}
        sx={{
          width: "100%",
          maxWidth: 460,
          borderRadius: 3,
          overflow: "hidden",
          border: "1px solid",
          borderColor: (theme) => theme.palette.mode === "dark" ?
            "rgba(123, 177, 160, 0.28)" :
            "rgba(0, 77, 64, 0.15)",
        }}
      >
        <Stack sx={{ px: 3, pt: 3, pb: 2, backgroundColor: (theme) => theme.palette.mode === "dark" ? "#182320" : "#f0f8f5" }}>
          <Box
            component="img"
            src={frecallLogoFull}
            alt="Frecall"
            sx={{ width: 138, height: "auto", mb: 1 }}
          />
          <Typography sx={{ fontSize: 12, fontWeight: 650, letterSpacing: 1, color: (theme) => theme.palette.mode === "dark" ? "#8ec8b7" : "#23695c" }}>
            F R E C A L L
          </Typography>
          <Typography variant="h5" sx={{ mt: 0.4, fontWeight: 700, color: "primary.main" }}>
            Agent Console
          </Typography>
          <Typography variant="body2" sx={{ color: "text.secondary", mt: 0.4 }}>
            Secure access for call-center agents
          </Typography>
        </Stack>
        <Box sx={{ px: 3, py: 2.5 }}>
          {props.view === "signin" ? (
            <SignIn setView={props.setView}/>
          ) : props.view === "signup" ? (
            <SignUp setView={props.setView}/>
          ) : (
            <Box />
          )}
        </Box>
      </Paper>
    </Box>
  )
}

export default Auth
